import { createSelector } from '@ngrx/store';

// State
import { IState } from '../index';

// Reducers
import { IPlayAudioState, playAudioFeatureKey } from './play-audio.reducer';

// Selector State
export const getPlayAudioState = (state: IState): IPlayAudioState => state[playAudioFeatureKey];

// Callbacks selectors
export const selectPlayAudio = (state: IPlayAudioState): boolean => state.state;

// Selector Data
export const getPlayAudio = createSelector(getPlayAudioState, selectPlayAudio);
